const News = ({ className }: { className: string }) => {
  return <div className={className} style={{ width: 300, height: 400 }} />;
};

export { News };
